import React, { Component } from 'react';
import Lightbox from 'react-image-lightbox';

// const images = [
//   '//placekitten.com/1500/500',
//   '//placekitten.com/4000/3000',
//   '//placekitten.com/800/1200',
//   '//placekitten.com/1500/1500',
// ];

export default class ProductLightbox extends Component {
  constructor(props) {
    super(props);

    this.state = {
      photoIndex: 0,
      isOpen: false,
      images: props.images
    };


    this.alt_text = this.alt_text.bind(this);

    this.big = this.big.bind(this);
    this.thumb = this.thumb.bind(this);
    this.medium = this.medium.bind(this);
    this.next = this.next.bind(this);
    this.previous = this.previous.bind(this);
  }

  alt_text(index){
    return this.state.images[index].alt_text; 
  }

  big(index){
    return this.state.images[index].large;
  }

  thumb(index){
    return this.state.images[index].thumb;
  }

  medium(index){
    return this.state.images[index].medium;
  }

  next(e){
    e.preventDefault();
    const { photoIndex, isOpen, images } = this.state;
    this.setState({
      photoIndex: (photoIndex + 1) % images.length,
    })
  }

  previous(e){
    e.preventDefault();
    const { photoIndex, isOpen, images } = this.state;
    this.setState({
      photoIndex: (photoIndex + images.length - 1) % images.length,
    })
  }

  render() {
    const { photoIndex, isOpen, images } = this.state;

    let thumbs = images.map( (img, index) => {
      return (
        <li key={index} className="img-responsive">
          <img src={this.thumb(index)} alt={this.alt_text(index)}   onClick={() => this.setState({ photoIndex: index })}/>
        </li>);
    });

    return (
      <div className="col-sm-5" style={{"padding": "10px 25px", "marginLeft": "-20px"}}>

    <div className='row carousel slide p-t-3'>
      <div className='carousel-outer'>
        <div className='carousel-inner'>
            <div className="item active">
      <img src={this.medium(photoIndex)} alt={this.alt_text(photoIndex)} onClick={() => this.setState({ isOpen: true })} style={{cursor: "pointer"}} />
            </div>
        </div>
      <a className='left carousel-control' data-turbolinks="false" href='#prev' onClick={this.previous} >
          <span className='glyphicon glyphicon-chevron-left'></span>
        </a>
        <a className='right carousel-control' data-turbolinks="false" href='#next' onClick={this.next}>
          <span className='glyphicon glyphicon-chevron-right'></span>
        </a>
      </div>
    </div>
    <div className="row">
      <div className="carousel-thumbs" id="slider-thumbs">
        <ul className="list-inline carousel-thumbs">
            {thumbs}
        </ul>
      </div>
    </div>
        {isOpen && (
          <Lightbox
          mainSrc={ this.big(photoIndex) }
          nextSrc={this.big((photoIndex + 1) % images.length)}
          prevSrc={this.big((photoIndex + images.length - 1) % images.length)}
          onCloseRequest={() => this.setState({ isOpen: false })}
          onMovePrevRequest= {this.previous}
          onMoveNextRequest= {this.next }
          />
        )}
  </div>

  );
  }
}
